import { format } from 'date-fns-tz';
import queryString from 'qs';

const getHostSummaryRequest = (filter) => {
  const payload = { yearMonth: format(filter?.yearMonth, 'yyyy-MM') };

  return queryString.stringify(payload);
};

export default getHostSummaryRequest;
